import * as React from "react";
import { Info } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Alert, AlertDescription } from "@/components/ui/alert";
const additionalCosts = [{
  item: "Flights to and from the destination clinic",
  cost: "Variable"
}, {
  item: "Accommodation (if choosing to stay outside the clinic's provided facilities)",
  cost: "From €60 / night"
}, {
  item: "Personal daily expenses (food, local transport, leisure)",
  cost: "Variable"
}, {
  item: "Comprehensive Travel Insurance",
  cost: "From €25"
}, {
  item: "Accompanying person's travel and accommodation",
  cost: "Variable"
}];
export default function AdditionalCostsNotCoveredByHse() {
  return;
}